import { useState } from 'react';
import { faqs } from '@/mocks/yy';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };

  return (
    <section id="faq" className="w-full py-16 md:py-24 bg-background-50">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium">
            <i className="ri-question-line" aria-hidden="true"></i>
            常见问题
          </span>
          <h2 className="mt-4 text-2xl md:text-4xl text-foreground-950">关于入口与登录，你关心的都在这里</h2>
          <p className="mt-4 text-foreground-700 text-sm md:text-base leading-relaxed">
            汇总了歪歪官方网站入口、登录、设备与使用的高频问题，帮你快速答疑解惑。
          </p>
        </div>

        <div className="mt-10 flex flex-col gap-3">
          {faqs.map((f, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div key={f.q} className="rounded-lg border border-background-200 bg-background-100 overflow-hidden">
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? -1 : idx)}
                  className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left"
                  aria-expanded={isOpen}
                >
                  <h3 className="text-sm md:text-base text-foreground-950 font-medium">{f.q}</h3>
                  <span className={`shrink-0 w-8 h-8 rounded-full bg-background-50 flex items-center justify-center text-foreground-600 transition-transform ${isOpen ? 'rotate-45' : ''}`}>
                    <i className="ri-add-line text-lg" aria-hidden="true"></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5">
                    <p className="text-sm text-foreground-700 leading-relaxed">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}